import { render, staticRenderFns } from "./LmColumnMenu.vue?vue&type=template&id=7c27cd10&scoped=true&"
import script from "./LmColumnMenu.vue?vue&type=script&lang=js&"
export * from "./LmColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./LmColumnMenu.vue?vue&type=style&index=0&id=7c27cd10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27cd10",
  null
  
)

export default component.exports